var _defs, _circle, _path, _path2, _polygon, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCircledEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebfcf1;}.cls-2{fill:#6f4c5b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_edit_circled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21,
    cy: 21,
    r: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.3,34.13a.89.89,0,0,1-.56-.2.87.87,0,0,1-.35-.74l.36-5.73,10-13.09a.94.94,0,0,1,1.33-.09l4.65,3.56A.94.94,0,0,1,30,19.15L19.83,32.44l-5.29,1.65A.67.67,0,0,1,14.3,34.13Zm.43-6.3-.33,5.26,4.83-1.51,9.91-12.94L24.5,15.08Z",
    transform: "translate(-1.81 -1.54)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.18,18.45a.48.48,0,0,1-.3-.11l-5.44-4.16a.53.53,0,0,1-.19-.33.49.49,0,0,1,.1-.37l1-1.27a2.62,2.62,0,0,1,3.55-.85l2.58,2a2.1,2.1,0,0,1,.79,1.72A3.19,3.19,0,0,1,31.55,17l-1,1.27a.45.45,0,0,1-.33.19Zm-4.73-4.76,4.64,3.56.67-.87a2.24,2.24,0,0,0,.48-1.33,1.1,1.1,0,0,0-.4-.92l-2.58-2c-.55-.43-1.54-.12-2.15.67Z",
    transform: "translate(-1.81 -1.54)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.61 30.8 15.31 28.09 12.1 26.58 12.53 25.68 16.01 27.36 18.37 30.16 17.61 30.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.53,28.26a.49.49,0,0,1-.3-.1.51.51,0,0,1-.1-.7l6.48-8.62a.49.49,0,0,1,.7-.09.5.5,0,0,1,.1.7l-6.48,8.61A.48.48,0,0,1,18.53,28.26Z",
    transform: "translate(-1.81 -1.54)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircledEdit);
export default __webpack_public_path__ + "static/media/ic_circled_edit.190667d69da8298d7b3989bcfd0598ec.svg";
export { ForwardRef as ReactComponent };